module.exports = __webpack_public_path__ + "img/icon-card.41bd6db0.svg";